import React, { PureComponent } from "react";
import { Link } from "gatsby";
import styled from "styled-components";
import Image from "../../src/Components/Image";

const Wrapper = styled.div`
  width: 367px;
  background-color: rgba(214, 185, 161, 0.5);
  border-radius: 17px;
  display: flex;
  flex-direction: column;
  margin-top: 4px;

  @media screen and (max-width: 479px) {
    width: 259px;
  }

  & > .view-btn {
    align-self: stretch;
    height: 22px;
    background-color: #fff;
    border-radius: 4px;
    display: none;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    margin: 6px 4px;
    text-decoration: none;

    @media screen and (max-width: 479px) {
      display: flex;
    }

    & > p {
      font-size: 13px;
      color: #b08963;
      letter-spacing: 1.3px;
    }
  }
`;

const MainWrapper = styled.div`
  padding: 5px 15px 5px 5px;
  display: flex;
  flex-direction: row;

  @media screen and (max-width: 479px) {
    padding: 5px 15px 0 5px;
  }

  & > .info-wrapper {
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    padding-left: 8px;

    & > .product-name {
      font-size: 14px;
      color: #000;
      letter-spacing: 1.3px;
      line-height: 19px;
      margin-bottom: 2px;
    }

    & > div {
      & > .product-info {
        font-size: 12px;
        color: #000;
        letter-spacing: 1.2px;
        line-height: 15px;
      }
    }

    & > .view-btn {
      align-self: stretch;
      height: 22px;
      background-color: #fff;
      border-radius: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      margin: 4px 2px 0 2px;
      text-decoration: none;

      @media screen and (max-width: 479px) {
        display: none;
      }

      & > p {
        font-size: 13px;
        color: #b08963;
        letter-spacing: 1.3px;
      }
    }
  }
`;

class ChattyProductItem extends PureComponent {
  render() {
    return (
      <Wrapper>
        <MainWrapper>
          <Image
            css="
              width: 110px; 
              height: 110px; 
              border-radius: 17px;
              @media screen and (max-width: 479px) {
                width: 71px;
                object-fit: cover;
              }
            "
            src="https://d20rvm4jdzc40u.cloudfront.net/media/product_images/coffee-171653_1280.jpg"
          />
          <div className="info-wrapper">
            <p className="product-name">衣索比亞耶家雪菲夏梅 SUMMER BERRY</p>
            <div>
              <p className="product-info">烘焙度：淺</p>
              <p className="product-info">處理法：遮陰日曬</p>
              <p className="product-info">風味敘述：梅子、莓果乾、香草</p>
            </div>
            <Link className="view-btn" to={`/product/?id=1`}>
              <p>查看該商品</p>
            </Link>
          </div>
        </MainWrapper>
        <Link className="view-btn" to={`/product/?id=1`}>
          <p>查看該商品</p>
        </Link>
      </Wrapper>
    );
  }
}

export default ChattyProductItem;
